import './EventHeader.css';

function EventHeader({ title, topic }) {
  return (
    <div className="event-header">
      <h1>{title}</h1>
      {topic && <div className="event-topic-badge">{topic}</div>}
    </div>
  );
}

export default EventHeader;
